import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../shared/AppSettings';
import { BehaviorSubject } from 'rxjs';
import { tPriceBookModel, tPriceModelWithItem } from '../models/tPriceBookModel';
import { LoggerService } from './Non-Master/logger.service';
import { preDefineCate } from '../models/tItemCateModel';




@Injectable({
    providedIn: 'root'
})

export class tPriceBookService {

    /*
    private selected_pack_itemID_Source = new BehaviorSubject('');
    current_selected_pack_itemID = this.selected_pack_itemID_Source.asObservable();

    private selected_pack_itemName_Source = new BehaviorSubject('');
    current_selected_pack_itemName = this.selected_pack_itemName_Source.asObservable();

    private selected_pack_itemUnit_Source = new BehaviorSubject('');
    current_selected_pack_itemUnit = this.selected_pack_itemUnit_Source.asObservable();

    private selected_pack_standardPrice_Source = new BehaviorSubject(0);
    current_selected_pack_standardPrice = this.selected_pack_standardPrice_Source.asObservable();

    shareSelected(selecteditemID: string, selecteditemName: string, selecteditemUnit: string, selectedStandardPrice: number) {
      this.selected_pack_itemID_Source.next(selecteditemID);
      this.selected_pack_itemName_Source.next(selecteditemName);
      this.selected_pack_itemUnit_Source.next(selecteditemUnit);

      this.selected_pack_standardPrice_Source.next(selectedStandardPrice);
    }
    */

    
    constructor(private http: HttpClient,
        private log: LoggerService,) { }

    baseurl: string = AppSettings.BaseURI;

    readonly pathName = '/tPriceBookModels';

    getAllData() {
        return this.http.get<tPriceBookModel[]>(this.baseurl + this.pathName);
    }

    getAllDataWithItemInfo(shopID: string) {
        return this.http.get<tPriceBookModel[]>(this.baseurl + this.pathName + '/WithItemInfo/' + shopID );
    }

    getDataById(shopID: string, itemID: string, patientTypeID: string) {
        // tslint:disable-next-line:max-line-length
        return this.http.get<tPriceBookModel[]>(this.baseurl + this.pathName + '/WithItemInfo/' + shopID + '/' + itemID + '/' + patientTypeID);
    }

    getConsultPriceBook(shopID: string, itemCateID: string, patientTypeID: string) {

        if (itemCateID === '') {
            itemCateID = preDefineCate.diagonsis;
        }

        this.log.i(' Price', this.baseurl + this.pathName + '/GetConsultPriceBook/' + shopID + '/' + itemCateID + '/' + patientTypeID);

        // tslint:disable-next-line:max-line-length
        return this.http.get<tPriceBookModel[]>(this.baseurl + this.pathName + '/GetConsultPriceBook/' + shopID + '/' + itemCateID + '/' + patientTypeID);
    }

    // addData(data: tPriceBookModel) {
    //     return this.http.post(this.baseurl + this.pathName + '/Formatted', data);
    // }

    addMultiData(data: any) {
        return this.http.post(this.baseurl + this.pathName + '/Formatted/Multi', data);
    }

    deleteData(data: tPriceBookModel) {

        this.log.i('DEL', this.baseurl + this.pathName + '/Formatted/' + data.shopID + '/' + data.itemID + '/' + data.patientTypeID);

        return this.http.delete(this.baseurl + this.pathName + '/Formatted/' + data.shopID + '/' + data.itemID + '/' + data.patientTypeID);
    }

    updateData(data: tPriceBookModel) {
        // tslint:disable-next-line:max-line-length
        return this.http.put(this.baseurl + this.pathName + '/Formatted/' + data.shopID + '/' + data.itemID + '/' + data.patientTypeID, data);
    }
}